import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import { ReadDepartment, WriteDepartment } from "@/types/department";

export const DepartmentService = new APIService<
  ReadDepartment,
  WriteDepartment
>(API.UpdatesDepartments);
export const fetchDepartmentList = DepartmentService.getList;
export const fetchDepartment = DepartmentService.get;
export const createDepartment = DepartmentService.post;
export const updateDepartment = DepartmentService.patch;
